import { useCallback, useState } from 'react';
import {
  getFuntionAnalyticsSponsored,
  setSponsoredDisplayDigitalDataClick,
  setSponsoredDisplayDigitalDataImpression,
} from '../../containers/ProductContainer/utils';
import _ from '../LodashImports';

export const useBannerActionHandler = ({ appCtx, config, categoryName, horizontalProduct, verticalProduct }) => {
  const [hasImpressionBeenSent, setHasImpressionBeenSent] = useState(false);

  const { tenant, deviceType, regionCode, store } = appCtx;
  const { MABAYA_TOKEN, MABAYA_EVENTS_ENABLED, FEATURE_TOGGLE_SPONSORED_VAS_SERVICE } = config;

  const handleBannerAction = useCallback(
    (product, action, adType) => {
      if (product == null) {
        return;
      }
      const sku = product.productId;
      const mPos = sku === horizontalProduct?.id ? 1 : 10;
      const { adInfo } = product;
      const providerName = _.get(product, 'providerName', null);
      const params = {
        mabayaToken: MABAYA_TOKEN,
        enabled: MABAYA_EVENTS_ENABLED,
        platform: deviceType,
        referrerUrl: window.location.href,
        sku,
        regionCode,
        adInfo,
        mPos,
        categoryName,
        tenant,
        store,
        ...(providerName && { providerName }),
        adType,
        productId: product.productId,
      };

      const isSponsoredService = FEATURE_TOGGLE_SPONSORED_VAS_SERVICE || false;
      const { sponsoredClickService: clickService, sponsoredImpressionService: impressionService } =
        getFuntionAnalyticsSponsored(isSponsoredService);

      if (action === 'click') {
        clickService(params);
        const currentUrl = product?.url;
        setSponsoredDisplayDigitalDataClick(sku, false);
        window.location.href = currentUrl;
      }

      if (action === 'impression' && !hasImpressionBeenSent) {
        const productsToTrack = [];
        if (horizontalProduct?.productId) {
          productsToTrack.push({
            sku: horizontalProduct.productId,
            adInfo: horizontalProduct.adInfo,
            mPos: '1',
            productId: horizontalProduct.productId,
            providerName: _.get(horizontalProduct, 'providerName', null),
          });
        }
        if (verticalProduct?.productId) {
          productsToTrack.push({
            sku: verticalProduct.productId,
            adInfo: verticalProduct.adInfo,
            mPos: '10',
            productId: verticalProduct.productId,
            providerName: _.get(verticalProduct, 'providerName', null),
          });
        }
        productsToTrack.forEach((productData) => {
          const individualImpressionParams = {
            ...params,
            sku: productData.sku,
            adInfo: productData.adInfo,
            mPos: productData.mPos,
            productId: productData.productId,
            ...(productData.providerName && { providerName: productData.providerName }),
          };
          impressionService(individualImpressionParams);
        });
        const allSkus = productsToTrack.map((p) => p.sku).join(',');
        setSponsoredDisplayDigitalDataImpression(allSkus, false);
        setHasImpressionBeenSent(true);
      }
    },
    [
      MABAYA_TOKEN,
      MABAYA_EVENTS_ENABLED,
      deviceType,
      regionCode,
      categoryName,
      tenant,
      horizontalProduct,
      verticalProduct,
      hasImpressionBeenSent,
      store,
    ]
  );

  return { handleBannerAction, hasImpressionBeenSent };
};
